import { BarChart3, MessagesSquare, Settings, type LucideIcon } from 'lucide-react';
import type { ChatbotTab } from './chatbotShared';

const tabItems: [ChatbotTab, string, LucideIcon][] = [
  ['config', 'Configuración', Settings],
  ['usage', 'Uso', BarChart3],
  ['conversations', 'Conversaciones', MessagesSquare],
];

export default function ChatbotTabs({
  tab,
  onChange,
}: {
  tab: ChatbotTab;
  onChange: (tab: ChatbotTab) => void;
}) {
  return (
    <div className="flex overflow-x-auto [&::-webkit-scrollbar]:hidden gap-1 border-b border-ui-border -mt-2">
      {tabItems.map(([key, label, Icon]) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`shrink-0 whitespace-nowrap flex items-center gap-2 px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${
            tab === key ? 'border-ui-accent text-ui-text' : 'border-transparent text-ui-text-muted hover:text-ui-text'
          }`}
        >
          <Icon size={15} /> {label}
        </button>
      ))}
    </div>
  );
}
